module.exports = __webpack_public_path__ + "static/img/jiuzhoulogo.fcd5e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/jiuzhoulogo.png
// module id = HWg/
// module chunks = 44